export const css = {
    root: '_12yR4Zxn',
    text: '_92legFCP',
    iconOnly: 'BXfRHdbm',
    disabled: '_2g1EhYDx',
    outlined: '_2WyIyGWy',
    label: '_18Q0dUhR',
    contained: '_3vuz-T7x',
    icon: 'qd27uTxI',
    ' _key': 'certwise-theme/dojo/button'
};
export default css;
